/******************************************************************************/
/* Copyright                                                                  */
/* ARS LUNA,                                                                  */
/* Helena Štibelj s.p.                                                        */
/* Čepulje 16                                                                 */
/* 4000 KRANJ                                                                 */
/*                                                                            */
/* http://www.arsluna.si, http://www.arsluna.com                              */
/* info@arsluna.si, info@arsluna.com                                          */
/* +386 (0)51 229 917                                                         */
/*                                                                            */
/* Sašo Štibelj                                                               */
/* +386 (0)41 951 959                                                         */
/*                                                                            */
/* All rights reserved.                                                       */
/* Copy or any use of all or part of this code is strictly forbidden without  */
/* written permision from Author                                              */
/******************************************************************************/
/* arsluna.content.js                                                         */
/* Ajax requests JS                                                           */
/*----------------------------------------------------------------------------*/
/* Version       Date         Change log                                      */
/* ------------+------------+------------------------------------------------ */
/* 3.0.0         16.02.2015   Object created                                  */
/* 3.0.1         22.11.2016   All xmlhttp requests changed to jquery ajax     */
/******************************************************************************/
function getStranSlikaPodatki(image_id) {
    $.ajax({
        async   : true,
        type    : "GET",
        url     : "/content/arsluna.proccess.php",
        data    : {"home_id" : image_id,
                   "p_timestamp" : new Date().getTime()
        },
        success : function (r) {
            podatki = r.split('|');
            if (podatki[0] !== undefined && podatki[0] !== 'undefined') {
                document.stran_slika_detajli.stran_slika_ime.value = podatki[0];
            }
            if (podatki[1] !== undefined && podatki[1] !== 'undefined') {
                document.getElementById('stran_slika_besedilo_prej').contentWindow.document.body.innerHTML = podatki[1];
                //document.stran_slika_detajli.stran_slika_besedilo_prej.body.value=podatki[1];
            }
            if (podatki[2] !== undefined && podatki[2] !== 'undefined') {
                document.getElementById('stran_slika_besedilo_potem').contentWindow.document.body.innerHTML = podatki[2];
                //document.stran_slika_detajli.stran_slika_besedilo_potem.value=podatki[2];
            }
        },
        error   : function(r,e) {
            console.log(r);
            console.log(e);
        }
    });
}
/******************************************************************************/
function getArtikelSlikaPodatki(image_id) {
    $.ajax({
        async   : true,
        type    : "GET",
        url     : "/content/arsluna.proccess.php",
        data    : {"artikel_id" : image_id,
                   "p_timestamp" : new Date().getTime()
        },
        success : function (r) {
            podatki = r.split('|');
            document.artikel_slika_detajli.artikel_slika_ime.value = '';
            document.artikel_slika_detajli.artikel_slika_title.value = '';
            document.artikel_slika_detajli.artikel_slika_besedilo_prej.value = '';
            document.artikel_slika_detajli.artikel_slika_besedilo_potem.value = '';
            if (podatki[0] !== undefined && podatki[0] !== 'undefined') {
                document.artikel_slika_detajli.artikel_slika_ime.value = podatki[0];
            }
            if (podatki[1] !== undefined && podatki[1] !== 'undefined') {
                //document.getElementById('artikel_slika_besedilo_prej').contentWindow.document.body.innerHTML=podatki[1];
                document.artikel_slika_detajli.artikel_slika_title.value = podatki[1];
            }
            if (podatki[2] !== undefined && podatki[2] !== 'undefined') {
                //document.getElementById('artikel_slika_besedilo_prej').contentWindow.document.body.innerHTML=podatki[1];
                document.artikel_slika_detajli.artikel_slika_besedilo_prej.value = podatki[2];
            }
            if (podatki[3] !== undefined && podatki[3] !== 'undefined') {
                //document.getElementById('artikel_slika_besedilo_potem').contentWindow.document.body.innerHTML=podatki[2];
                document.artikel_slika_detajli.artikel_slika_besedilo_potem.value = podatki[3];
            }
        },
        error   : function(r,e) {
            console.log(r);
            console.log(e);
        }
    });
}
/******************************************************************************/
function countComercialClick(reklame_pk) {
    $.ajax({
        async   : true,
        type    : "GET",
        url     : "/content/arsluna.proccess.php",
        data    : {"reklame_pk"  : reklame_pk,
                   "p_timestamp" : new Date().getTime()
        },
        success : function (r) {
            return;
        },
        error   : function(r,e) {
            console.log(r);
            console.log(e);
        }
    });
}
/******************************************************************************/
function countClick(p_request, p_id) {
    $.ajax({
        async   : true,
        type    : "GET",
        url     : "/content/arsluna.proccess.php",
        data    : {"p_request"   : p_request,
                    "p_id"       : p_id,
                   "p_timestamp" : new Date().getTime()
        },
        success : function (r) {
            return;
        },
        error   : function(r,e) {
            console.log(r);
            console.log(e);
        }
    });
}
/******************************************************************************/
function getVeljavnaCenaArtikelAtt(p_AttDetailPk, p_ArtikliPk, p_Prefix) {
    $.ajax({
        async   : true,
        type    : "GET",
        url     : "/content/arsluna.proccess.php",
        data    : {"p_veljavnaCenaAttDetail"   : "1",
                   "p_AttDetailPk" : p_AttDetailPk,
                   "p_ArtikliPk"   : p_ArtikliPk,
                   "p_timestamp"   : new Date().getTime()
        },
        success : function (r) {
            podatki = r.split('|');
            if (podatki[0] !== undefined && podatki[0] !== 'undefined') {
                document.getElementById(p_Prefix + 'artikelCena_' + p_ArtikliPk).innerHTML = podatki[0];
            }
            if (podatki[1] !== undefined && podatki[1] !== 'undefined') {
                document.getElementById(p_Prefix + 'artikelPopust_' + p_ArtikliPk).innerHTML = podatki[1];
            }
            if (podatki[2] !== undefined && podatki[2] !== 'undefined') {
                document.getElementById(p_Prefix + 'artikelCenaAkcija_' + p_ArtikliPk).innerHTML = podatki[2];
            }
        },
        error   : function(r,e) {
            console.log(r);
            console.log(e);
        }
    });
}
/******************************************************************************/
function removeLi(el, kosarica_pk, kosarice_pk) {
    $.ajax({
        async   : true,
        type    : "GET",
        url     : "/content/arsluna.proccess.php",
        data    : {"p_request"     : "kosaricaKratkoDeleteRow",
                   "p_kosarica_pk" : kosarica_pk,
                   "p_kosarice_pk" : kosarice_pk,
                   "p_timestamp"   : new Date().getTime()
        },
        success : function (r) {
            vrednost = r.split('|');
            if (vrednost[0]) {
                el = el.parentNode;
                if (el && el.parentNode) {
                    el.parentNode.removeChild(el);
                }
                document.getElementById('kosaricaKratkoVrednost').innerHTML = vrednost[0];
                document.getElementById('kosaricaKratkoStArt').innerHTML = vrednost[1];
                if (vrednost[0] == '0,00') {
                    el = document.getElementById('kosaricaKratkoBottom');
                    if (el && el.parentNode)
                        el.parentNode.removeChild(el);
                    el = document.getElementById('kosaricaKratkoButton');
                    if (el && el.parentNode)
                        el.parentNode.removeChild(el);
                }
            }
        },
        error   : function(r,e) {
            console.log(r);
            console.log(e);
        }
    });
}
/******************************************************************************/
function uploadImage(p_path) {
    $.ajax({
        async   : true,
        type    : "GET",
        url     : "/content/arsluna.proccess.php",
        data    : {"p_request"   : "uploadImage",
                   "p_path"      : p_path,
                   "p_timestamp" : new Date().getTime()
        },
        success : function (r) {
            vrednost = r.split('|');
        },
        error   : function(r,e) {
            console.log(r);
            console.log(e);
        }
    });
}
/******************************************************************************/
